import React from 'react'
import Splash from '../components/splash';
import Welcome from '../components/welcome';
import NextMeeting from '../components/nextMeeting';
import Highlight from '../components/highlight';
import { homeData } from '../data/home';

class Home extends React.Component{
    render(){
        const { splash, nextMeeting, highlight } = homeData;

        return (
            <div>
                <Splash
                    imageSrc={splash.src}
                    title={splash.title}
                    photographer={splash.photographer}
                />
                <Welcome 
                />
                <NextMeeting
                    date={nextMeeting.date}
                    about={nextMeeting.about}
                />
                <Highlight
                    title={highlight.title}
                    about={highlight.about}
                />
          </div>
        );
    }
}

export default Home;


// WEBPACK FOOTER //
// ./src/pages/home.jsx